import { useEffect, useState } from 'react'
import NumerologyApi from '../../services/numerology'
import { IDataChartNumerology } from '../../services/numerology/@type'
import BoxHeaderPrimary from './BoxHeaderPrimary'
import { IndustryCss } from './index.css'
interface IProps {
	rulingNumber: number | null
	descriptionPersonalities?: string
	rulingNumberJobs?: IDataChartNumerology[]
}
export default function Industry({
	rulingNumber,
	descriptionPersonalities,
	rulingNumberJobs = []
}: IProps) {
	const [jobs, setJobs] = useState<IDataChartNumerology[] | null>(
		rulingNumberJobs
	)

	const getJobNumerologyByJobCategory = async (rulingNumber: number) => {
		try {
			const data = await NumerologyApi.getJobNumerologyByJobCategoryV2(
				rulingNumber
			)
			if (data) {
				setJobs(data)
			}
		} catch (error) {
			console.error(error)
		}
	}
	useEffect(() => {
		getJobNumerologyByJobCategory(rulingNumber ?? 0)
	}, [rulingNumber])
	return (
		<BoxHeaderPrimary title='Top ngành nghề phù hợp với số chủ đạo'>
			<IndustryCss>
				<div className='title'>
					<p>
						Đặc tính số <span>{rulingNumber ?? 0}</span>:
					</p>
					<span>{descriptionPersonalities ?? ''}</span>
				</div>
				<div className='industry__block'>
					<div className='industry__block--title'>
						<p>Ngành nghề phù hợp với số chủ đạo của bạn</p>
					</div>
					<div className='industry__block--list'>
						{jobs
							? jobs.map((item, index) => {
									return (
										<div className='item' key={index}>
											<div
												className='item__color'
												style={{
													backgroundColor: item.color
												}}
											/>
											<div className='item__title'>
												{item.industryName}
											</div>
										</div>
									)
							  })
							: null}
					</div>
				</div>
			</IndustryCss>
		</BoxHeaderPrimary>
	)
}
